/* Homepage-only behaviour. Shared behaviour (buy box, dialogs, carousels, marquee/rotator pause, reveal)
   lives in assets/kenetik.js, which kenetik-styles loads once on every page. */
(function () {
  if (window.__kxHome) return; window.__kxHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Count-up (21st.dev "number ticker" mechanic): eased rAF, runs once when visible.
     The server renders the final, formatted value; that is also the no-JS / reduced-motion state. */
  document.querySelectorAll('[data-countup]').forEach(function (el) {
    var target = parseInt(el.dataset.countup, 10), suffix = el.dataset.suffix || '';
    var from = parseInt(el.dataset.countupFrom, 10); if (isNaN(from) || from >= target) from = 0;
    var dur = parseInt(el.dataset.countupMs, 10) || 1400;
    var fmt = function (n) { return n.toLocaleString('en-US') + suffix; };
    if (isNaN(target) || reduce || !('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return; cio.disconnect();
      var t0 = performance.now();
      (function tick(now) {
        var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(from + (target - from) * e));
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    }, { threshold: 0.5 });
    cio.observe(el);
  });
})();
